import { Injectable } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { FileDto, ErrorFileDto } from '@shared/service-proxies/service-proxies';

@Injectable()
export class FileDownloadService {

    downloadTempFile(file: FileDto) {
        const url = AppConsts.remoteServiceBaseUrl + '/File/DownloadTempFile?fileType=' + file.fileType + '&fileToken=' + file.fileToken + '&fileName=' + file.fileName;
        location.href = url; 
    }
    downloadTempFiles(fileDto: ErrorFileDto): void {
       
        const fileDownloadData = {
          FileName: fileDto.fileName,  
          FileContent: fileDto.fileContent  
        };
      
       
        const byteCharacters = atob(fileDownloadData.FileContent);  
        const byteArrays = new Uint8Array(byteCharacters.length);
      
        for (let i = 0; i < byteCharacters.length; i++) {
          byteArrays[i] = byteCharacters.charCodeAt(i);
        }
      
        const fileBlob = new Blob([byteArrays], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(fileBlob);  
        link.download = fileDownloadData.FileName; 
        link.click();  
      }
      
}
